/* HELLO SLIM — marka scripti (reveal animasyonları). Tek sefer çalışır. */
(function () {
  'use strict';
  if (window.__hsBrand) return;
  window.__hsBrand = true;

  function init() {
    var items = document.querySelectorAll('.hs-rv');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    items.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
